module.exports = __webpack_public_path__ + "img/menu_close.svg";